export const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 599px)",
  medium: "(min-width: 600px) and (max-width: 1199px)",
  large: "(min-width: 1200px)",
};


export const primaryColors = [
  "#1D2D50",
  "#2F395B",
  "#414769",
  "#555777",
  "#6A6A87",
  "#817F98",
  "#9795AB",
  "#B0ADBE",
  "#C9C7D3",
  "#E3E2E9",
];

export const secondaryColors = [
  "#E84F3D",
  "#EB654E",
  "#EE795F",
  "#F08B72",
  "#F39E85",
  "#F5AF99",
  "#F8C1AD",
  "#FAD1C2",
  "#FCE1D6",
  "#FEF0EB",
];

export const colors1 = [
  "#5AC3E3",
  "#74CAE6",
  "#89D0EA",
  "#9BD6ED",
  "#ACDCF0",
  "#BCE3F3",
  "#CBE9F6",
  "#D8EEF8",
  "#E6F4FB",
  "#F3FAFD",
];


export const colors2 = [
    "#008BAD",
    "#3B95B5",
    "#5BA0BD",
    "#75ABC5",
    "#8CB6CD",
    "#A1C2D5",
    "#B5CEDE",
    "#C9DAE6",
    "#DBE6EF",
    "#EDF3F7",
  ];

  
  export const colors3 = [
    "#DDE2EA",
    "#E0E4EC",
    "#E4E8EE",
    "#E7EAF1",
    "#EBEDF3",
    "#EEF0F5",
    "#F1F3F7",
    "#F5F6F9",
    "#F8F9FB",
    "#FCFCFD",
  ];

  
  export const colors4 = [
    "#FAB513",
    "#FBBC38",
    "#FCC453",
    "#FDCB6C",
    "#FED384",
    "#FEDB9A",
    "#FFE2B0",
    "#FFE9C4",
    "#FFF1D9",
    "#FFF8EC",
  ];

  
  export const colors5 = [
    "#03AA72",
    "#44B280",
    "#65BB8F",
    "#7FC49D",
    "#96CDAB",
    "#AAD5BA",
    "#BDDEC8",
    "#CFE7D7",
    "#E0EFE5",
    "#F0F7F3",
  ];

  
